import { render, staticRenderFns } from "./TeamOptions.vue?vue&type=template&id=49c08594"
import script from "./TeamOptions.vue?vue&type=script&lang=js"
export * from "./TeamOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports